import { createSlice } from "@reduxjs/toolkit";

const historySlice = createSlice({
    name: "history",
    initialState: {
        visibleRight: false,
        showEditDelete: {},
        current: null,
        hover: null
    },
    reducers: {
        setVisibleRight(state, action) {
            state.visibleRight = action.payload
        },
        setShowEditDelete(state, action) {
            state.showEditDelete = action.payload
        },
        setCurrent(state, action) {
            state.current = action.payload
        },
        setHover(state, action) {
            state.hover = action.payload
        },
    }
})

export const { setVisibleRight, setShowEditDelete, setCurrent, setHover } = historySlice.actions;
export default historySlice.reducer;